module.exports = __webpack_public_path__ + "img/Arrow.7a00cfcd.svg";